type NavigationResult = {
  success: boolean;
  message: string;
  url?: string;
};

/**
 * Attempts to navigate to a website URL
 * @param url The URL to navigate to
 * @returns Promise resolving to a NavigationResult object
 * TO DO: USE AXIOS INSTEAD
 */
async function navigateToWebsite(url: string): Promise<NavigationResult> {
  // Add protocol if missing
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    url = "https://" + url;
  }

  try {
    // Check if the website exists
    const response = await fetch(url, {
      method: "HEAD",
      mode: "no-cors",
    });

    // For successful navigation
    return {
      success: true,
      message: `Successfully navigated to ${url}`,
      url: url,
    };
  } catch (error) {
    // For failed navigation
    return {
      success: false,
      message: `Failed to navigate to ${url}: ${
        error instanceof Error ? error.message : String(error)
      }`,
    };
  }
}

export default navigateToWebsite;
